import AddBankOffer from "../../../jsx/components/Dashboard/BankwiseOffer/addbankoffer";

const AddBankOfferWrapper = () => {
  return <AddBankOffer />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(AddBankOfferWrapper);
